"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_SOLR_FACET_SPLIDE = exports.DATA_SOLR_FACETING = exports.DATA_SOLR_FORM_RESET = exports.DATA_SOLR_FORM_INPUT = exports.DATA_SOLR_FORM = exports.DATA_SOLR = exports.DATA_PORTAL_MODAL_CLOSE = exports.DATA_PORTAL_MODAL = exports.DATA_PORTAL_BUTTON = exports.DATA_CONTACT_MODAL_CLOSE = exports.DATA_CONTACT_MODAL = exports.DATA_CONTACT_BUTTON = exports.DATA_FORM_SELECT_MULTIPLE_OPTION = exports.DATA_FORM_SELECT_MULTIPLE_RESULTS = exports.DATA_FORM_SELECT_MULTIPLE = exports.DATA_FORM_SUBMIT = exports.DATA_FORM_HIDE = exports.DATA_FORM = exports.DATA_FADE = exports.DATA_STICKY_LEAD_BUTTON = exports.DATA_STICKY_BUTTON_WRAP = exports.DATA_FOOTER = exports.DATA_HEADER_BOTTOM = exports.DATA_HEADER_TOP = exports.DATA_HEADER = exports.DATA_NAV_ITEM_DROPDOWN = exports.DATA_NAV_ITEM_INITIAL = exports.DATA_NAVBAR_SOCIAL = exports.DATA_NAVBAR_META = exports.DATA_SUBMENU_BACKLINK = exports.DATA_SUBMENU = exports.DATA_SUBMENU_TRIGGER = exports.DATA_NAVBAR_MAIN_WRAP = exports.DATA_NAV_TOGGLE = exports.DATA_PAGE_INTRO = exports.DATA_COUNTER = exports.DATA_PASSWORD_TOGGLE = exports.DATA_ACCORDION = exports.DATA_SLIDER = void 0;
exports.DATA_SLIDER = 'data-slider';
exports.DATA_ACCORDION = 'data-bs-toggle="collapse"';
exports.DATA_PASSWORD_TOGGLE = 'data-password-toggle';
exports.DATA_COUNTER = 'data-counter';
exports.DATA_PAGE_INTRO = 'data-page-intro';
// Navigation
exports.DATA_NAV_TOGGLE = 'data-nav-toggle';
exports.DATA_NAVBAR_MAIN_WRAP = 'data-navbar-main-wrap';
exports.DATA_SUBMENU_TRIGGER = 'data-submenu-trigger';
exports.DATA_SUBMENU = 'data-submenu';
exports.DATA_SUBMENU_BACKLINK = 'data-submenu-backlink';
exports.DATA_NAVBAR_META = 'data-navbar-meta';
exports.DATA_NAVBAR_SOCIAL = 'data-navbar-social';
exports.DATA_NAV_ITEM_INITIAL = 'data-nav-item-initial';
exports.DATA_NAV_ITEM_DROPDOWN = 'data-nav-item-dropdown';
// Header
exports.DATA_HEADER = 'data-header';
exports.DATA_HEADER_TOP = 'data-header-top';
exports.DATA_HEADER_BOTTOM = 'data-header-bottom';
exports.DATA_FOOTER = 'data-footer';
exports.DATA_STICKY_BUTTON_WRAP = 'data-sticky-button-wrap';
exports.DATA_STICKY_LEAD_BUTTON = 'data-sticky-lead-button';
exports.DATA_FADE = 'data-fade';
// Forms
exports.DATA_FORM = 'data-form';
exports.DATA_FORM_HIDE = 'data-form-hide';
exports.DATA_FORM_SUBMIT = 'data-form-submit';
exports.DATA_FORM_SELECT_MULTIPLE = 'data-form-select-multiple';
exports.DATA_FORM_SELECT_MULTIPLE_RESULTS = 'data-form-select-multiple-results';
exports.DATA_FORM_SELECT_MULTIPLE_OPTION = 'data-form-select-multiple-option';
// Contact Modal
exports.DATA_CONTACT_BUTTON = 'data-contact-button';
exports.DATA_CONTACT_MODAL = 'data-contact-modal';
exports.DATA_CONTACT_MODAL_CLOSE = 'data-contact-modal-close';
exports.DATA_PORTAL_BUTTON = 'data-portal-button';
exports.DATA_PORTAL_MODAL = 'data-portal-modal';
exports.DATA_PORTAL_MODAL_CLOSE = 'data-portal-modal-close';
// Search
exports.DATA_SOLR = 'data-solr';
exports.DATA_SOLR_FORM = 'data-solr-form';
exports.DATA_SOLR_FORM_INPUT = 'data-solr-form-input';
exports.DATA_SOLR_FORM_RESET = 'data-solr-form-reset';
exports.DATA_SOLR_FACETING = 'data-solr-faceting';
exports.DATA_SOLR_FACET_SPLIDE = 'data-solr-facet-splide';
